<template>
    <div class="mt-8 py-2">
        <div @click="close()" class="btn btn-square btn-sm btn-ghost absolute top-0 right-0 m-1 close-z-100">
            <span class="material-symbols-outlined notranslate fill-current">
                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/></svg>
            </span>
        </div>
        <div class="overflow-y-auto h-screen locationdetail-content-height">
            <div class="mx-0">
                <div id="location_detail">
                    <div
                        class="slider_box"
                        :style="
                            location.images.length == 0 && location.videos.length == 0 && 'height: 60px;'
                        "
                        :class="{ 'hidden': currentState === 'half' }"
                        style="z-index:1"
                    >
                        <div v-if="location.images.length > 0 || location.videos.length > 0">
                            <div class="slider_img bg-base-300">
                                <div class="slide" v-for="(imageUrl, index) in location.images" :key="index">
                                    <a class="fancybox" :href="imageUrl" data-fancybox="slides">
                                        <img :src="imageUrl" loading="lazy" />
                                    </a>
                                </div>
                                <div
                                    class="slide"
                                    v-for="(video, index) in location.videos"
                                    :key="'vid-' + index"
                                >
                                    <a
                                        class="fancybox"
                                        :href="
                                            isYoutubeLink(video) ? video : '/storage/video/' + video
                                        "
                                        data-fancybox="slides"
                                    >
                                        <iframe
                                            height="245"
                                            width="100%"
                                            :src="video + '?&autoplay=1&mute=1'"
                                            v-if="isYoutubeLink(video)"
                                            loading="lazy"
                                        >
                                        </iframe>
                                        <video height="100%" width="100%" v-else>
                                            <source
                                                :src="'/storage/video/' + video"
                                                type="video/mp4"
                                            />
                                        </video>
                                    </a>
                                </div>
                            </div>
                            <div class="thumb_list bg-base-300">
                                <div
                                    class="thumb"
                                    v-for="(imageUrl, index) in location.images"
                                    :key="'slide-img-' + index"
                                >
                                    <img :src="imageUrl" loading="lazy" />
                                </div>
                                <div
                                    class="thumb"
                                    v-for="(video, index) in location.videos"
                                    :key="'slide-vid-' + index"
                                >
                                    <img src="/img/icon_play.svg" loading="lazy" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="description" style="z-index:2" :style="[ currentState === 'half' ? { 'padding-top': 'unset' } : '' ]">
                        <div :class="{ 'flex px-2': currentState === 'half' }">
                            <div class="m-5">
                                <div :class="{ 'avatar_base': currentState !== 'half' }">
                                    <div class="avatar">
                                        <div
                                            class="w-20 h-20 ring ring-primary ring-offset-base-100 ring-offset-2"
                                            :class="[ location.marker_style !== 'square' && location.marker_style !== 'icon' ? 'rounded-full' : 'rounded', currentState === 'half' ? 'w-14 h-14' : 'w-20 h-20',location.marker_style === 'custom' ? 'rounded bg-base-100' : 'bg-primary',]"
                                        >
                                            <img :src="location.marker_image_url" loading="lazy" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div :class="{ 'm-5': currentState !== 'half' }">
                                <p class="font-bold mb-1 break-words my-3 text-lg text-overflow-wrap"
                                >
                                    {{ location.title }}
                                </p>
                                <div class="" v-if="location.sub_title">
                                    <p
                                        class="mb-1 text-base-content text-opacity-80 break-words text-overflow-wrap"
                                    >
                                        {{ location.sub_title }}
                                    </p>
                                </div>
                                <button
                                    class="btn btn-sm rounded-full normal-case mb-1"
                                    :class="[ currentState !== 'half' ? 'btn-sm location-category' : 'btn-xs text-xs' ]"
                                    @click="chooseCategory"
                                >
                                    {{ location.category.title }}
                                </button>
                                <div v-if="showCongestion">
                                    <div class="text-sm mt-2 justify-start py-2">
                                        <congestion-icon-level
                                            :title="location.current_congestion.title"
                                            :level="location.current_congestion.level"
                                            :type="1"
                                        >
                                        </congestion-icon-level>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="currentState !== 'half'">
                            <div class="m-5" v-if="location.description">
                                <div class="text-base-content text-base font-medium text_overflow pb-0">
                                    <span v-readMore:150="location.description"></span>
                                </div>
                            </div>
                            <div class="m-5" v-if="location.audio_guide">
                                <a
                                    :href="`/${hashId}/audio/${location.audio_guide.id}/${defaultLocale}`"
                                    target="_blank"
                                >
                                    <button class="btn w-full btn-accent btn-sm my-2 normal-case fill-current">
                                        <span
                                            class="material-symbols-outlined notranslate fill-current"
                                            style="font-size: large"
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M360-120H200q-33 0-56.5-23.5T120-200v-280q0-75 28.5-140.5t77-114q48.5-48.5 114-77T480-840q75 0 140.5 28.5t114 77q48.5 48.5 77 114T840-480v280q0 33-23.5 56.5T760-120H600v-320h160v-40q0-117-81.5-198.5T480-760q-117 0-198.5 81.5T200-480v40h160v320Zm-80-240h-80v160h80v-160Zm400 0v160h80v-160h-80Zm-400 0h-80 80Zm400 0h80-80Z"/></svg>                                    </span>
                                        <span class="ml-1">{{ trans.spot_detail.audio_guide }}</span>
                                    </button>
                                </a>
                            </div>
                            <div class="mx-5 my-1" v-if="parcelAndLayerTitle">
                                    <p class="mb-1">
                                        <div class="text-primary text-opacity-80 break-words text-sm">{{ parcelAndLayerTitle }}</div>
                                        <div class="text-primary text-opacity-80 break-words text-sm">{{ currentLayerTitle }}</div>
                                    </p>
                            </div>
                            <div v-if="upperAreas.length">
                                <div class="px-4 my-1">
                                    <div class="mx-1 text-sm font-bold text-base-content/50">
                                        <span class="material-symbols-outlined notranslate fill-current v-align-sub">
                                            <svg xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 -960 960 960" width="16"><path d="M480-480q33 0 56.5-23.5T560-560q0-33-23.5-56.5T480-640q-33 0-56.5 23.5T400-560q0 33 23.5 56.5T480-480Zm0 294q122-112 181-203.5T720-552q0-109-69.5-178.5T480-800q-101 0-170.5 69.5T240-552q0 71 59 162.5T480-186Zm0 106Q319-217 239.5-334.5T160-552q0-150 96.5-239T480-880q127 0 223.5 89T800-552q0 100-79.5 217.5T480-80Zm0-480Z"/></svg>
                                        </span>
                                        <span
                                            class="upper-areas"
                                            v-for="area in upperAreas"
                                            :key="'area' + area.id"
                                        >
                                            {{ getAreaTitle(area) }}
                                            <span v-if="area !== upperAreas[upperAreas.length - 1]" class="mx-1">/</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="divider my-1 mx-2"></div>
                            <ul class="">
                                <template v-for="(customField, index) in location.custom_fields">
                                    <li :key="index" class="flex mx-5 my-3">
                                        <div class="flex items-center space-x-4">
                                            <div class="w-16">
                                                <div
                                                    class="font-semibold text-base-content/50 text-sm w-16"
                                                >
                                                    {{ transTitle(customField.title) }}
                                                </div>
                                            </div>
                                            <div>
                                                <a
                                                    :href="
                                                        getCustomLink(
                                                            customField.title,
                                                            customField.text
                                                        )
                                                    "
                                                    :target="
                                                        isURLField(customField.title) ? '_blank' : ''
                                                    "
                                                    rel="noopener noreferrer"
                                                    ><div
                                                        :class="{
                                                            'btn-link link-secondary': isURLField(
                                                                customField.title
                                                            ),
                                                            'text-base-content': !isURLField(
                                                                customField.title
                                                            ),
                                                            'text_overflow pb-0 text-base': true
                                                        }"
                                                    >
                                                        <span>{{ customField.text }}</span>
                                                    </div></a
                                                >
                                            </div>
                                        </div>
                                    </li>
                                    <div class="divider my-1 mx-2" :key="'divider-' + index"></div>
                                </template>
                            </ul>
                            <ul
                                class=""
                                v-show="location.items.length > 0 || location.facilities.length > 0"
                            >
                                <template v-if="location.items.length > 0">
                                    <li>
                                        <div class="mx-5 my-2">
                                            <div class="font-bold text-base-content/50 text-sm">
                                                {{ trans.spot_detail.item }}
                                            </div>
                                            <div class="my-3 flex flex-wrap">
                                                <button
                                                    class="group flex items-center my-2 mx-5 ml-0"
                                                    v-for="item in location.items"
                                                    :key="item.id"
                                                >
                                                    <img
                                                        :src="item.image_url"
                                                        alt=""
                                                        class="shrink-0 h-8 w-8"
                                                        loading="lazy"
                                                    />
                                                    <div
                                                        class="text-base-content text-left text_overflow pb-0 text-sm ml-2"
                                                    >
                                                        <span>{{ item.title }}</span>
                                                    </div>
                                                </button>
                                            </div>
                                        </div>
                                    </li>
                                    <div class="divider my-1 mx-2"></div>
                                </template>
                                <template v-if="location.facilities.length > 0">
                                    <li>
                                        <div class="mx-5 my-2">
                                            <div class="font-bold text-base-content/50 text-sm">
                                                {{ trans.spot_detail.facility }}
                                            </div>
                                            <div class="my-3 flex flex-wrap">
                                                <button
                                                    class="group flex items-center my-2 mx-5 ml-0"
                                                    v-for="facility in location.facilities"
                                                    :key="facility.id"
                                                >
                                                    <img
                                                        :src="facility.image_url"
                                                        alt=""
                                                        class="shrink-0 h-8 w-8"
                                                        loading="lazy"
                                                    />
                                                    <div
                                                        v-show="!facility.is_hidden_title"
                                                        class="text-base-content text-left text_overflow pb-0 text-sm ml-2"
                                                    >
                                                        <span>{{ facility.title }}</span>
                                                    </div>
                                                </button>
                                            </div>
                                        </div>
                                    </li>
                                    <div class="divider my-1 mx-2"></div>
                                </template>
                            </ul>

                            <template v-if="location.banners.length > 0 || location.partner_id">
                                <div
                                    class="grid w-full grid-cols-1 gap-4 p-4 py-1"
                                    v-if="location.partner_id && hasNoAPIBanner()"
                                >
                                    <a :href="individualLink" target="_blank" rel="noopener noreferrer"
                                        ><div class="card bg-base-100 image-full banner">
                                            <figure>
                                                <img
                                                    src="/img/rally-banner.png"
                                                    alt=""
                                                    loading="lazy"
                                                />
                                            </figure>
                                            <div class="card-body flex justify-center space-x-2">
                                                <div class="flex space-x-2">
                                                    <div class="avatar">
                                                        <div class="w-12 h-12 rounded">
                                                            <img
                                                                src="/img/rally-icon.png"
                                                                alt=""
                                                                loading="lazy"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <h2 class="card-title text-base text-white">
                                                            {{ trans.spot_detail.stamprally }}
                                                        </h2>
                                                        <p class="text-white">
                                                            {{ trans.spot_detail.stamprally_sub }}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div></a
                                    >
                                </div>
                                <div
                                    class="grid w-full grid-cols-1 gap-4 p-4 py-1"
                                    v-else
                                    v-for="(banner, index) in location.banners"
                                    :key="index"
                                >
                                    <a
                                        :href="banner.type == 2 ? individualLink : banner.link"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        ><div
                                            class="card bg-base-100 image-full banner"
                                            @click="handleBanner(banner)"
                                        >
                                            <figure
                                                :style="
                                                    !banner.background_image
                                                        ? 'background-image: linear-gradient(45deg,' +
                                                        banner.color_1 +
                                                        ',' +
                                                        banner.color_2 +
                                                        ')'
                                                        : ''
                                                "
                                            >
                                                <img
                                                    v-if="banner.background_image"
                                                    :src="banner.background_image"
                                                    alt=""
                                                    loading="lazy"
                                                />
                                            </figure>
                                            <div class="card-body flex justify-center space-x-2">
                                                <div class="flex space-x-2">
                                                    <div class="avatar" v-if="banner.icon">
                                                        <div
                                                            class="w-12 h-12 rounded __web-inspector-hide-shortcut__"
                                                        >
                                                            <img
                                                                :src="banner.icon"
                                                                alt=""
                                                                loading="lazy"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <h2 class="card-title text-base text-white">
                                                            {{ banner.link_title }}
                                                        </h2>
                                                        <p class="text-white">{{ banner.sub_title }}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div></a
                                    >
                                </div>
                                <div class="divider my-1 mx-2"></div>
                            </template>
                            <template v-if="useQRCode && qrImageURL">
                                <div class="grid w-full grid-cols-1 gap-4 p-4 py-1">
                                    <div class="qrcode text-center p-4 m-auto">
                                        <div class="text-sm mb-3">{{ location.qr_title }}</div>
                                        <img class="w-44 m-auto my-4" :src="qrImageURL" />
                                    </div>
                                </div>
                                <div class="divider my-1 mx-2"></div>
                            </template>
                            <div class="w-full p-2 pb-0 content-directions" v-if="useMapboxDirections || useGoogleMapDirections">
                                <div class="grid w-full grid-cols-1 gap-4">
                                    <button
                                        v-if="useMapboxDirections"
                                        class="btn btn-neutral btn-block"
                                        @click="openDirectionsControl()"
                                    >
                                        {{ trans.spot_detail.directions }}
                                    </button>
                                    <button
                                        v-if="useGoogleMapDirections"
                                        class="btn btn-block"
                                        @click="openGoogleMap()"
                                    >
                                    <div class="flex flex-col">
                                        <span>{{ trans.spot_detail.directions }}</span>
                                        <span class="text-base-content/50 hidden text-xs font-normal md:block mt-1">{{ trans.spot_detail.moveto_googlemap}}</span>
                                    </div>
                                    </button>
                                </div>
                                <div class="divider my-1"></div>
                            </div>
                            <template v-if="location.sns_link.length > 0">
                                <div class="flex flex-wrap justify-end gap-4 mx-5 p-5">
                                    <a
                                        v-for="(sns, index) in location.sns_link"
                                        :key="index"
                                        :href="sns.link"
                                        target="_blank"
                                    >
                                        <svg
                                            v-if="sns.name === 'twitter'"
                                            xmlns="http://www.w3.org/2000/svg"
                                            height="24"
                                            viewBox="0 0 512 512"
                                            class="bi bi-twitter"
                                            fill="currentColor"
                                        >
                                            <path
                                                d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"
                                            >
                                                >
                                            </path>
                                        </svg>
                                        <svg
                                            v-if="sns.name === 'youtube'"
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            fill="currentColor"
                                            class="bi bi-youtube"
                                            viewBox="0 0 16 16"
                                        >
                                            <path
                                                d="M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.007 2.007 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.007 2.007 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31.4 31.4 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.007 2.007 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A99.788 99.788 0 0 1 7.858 2h.193zM6.4 5.209v4.818l4.157-2.408L6.4 5.209z"
                                            ></path>
                                        </svg>
                                        <svg
                                            v-if="sns.name === 'facebook'"
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24 "
                                            fill="currentColor"
                                            class="bi bi-facebook"
                                            viewBox="0 0 16 16"
                                        >
                                            <path
                                                d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z"
                                            ></path>
                                        </svg>
                                        <svg
                                            v-if="sns.name === 'line'"
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            fill="currentColor"
                                            class="bi bi-line"
                                            viewBox="0 0 16 16"
                                        >
                                            <path
                                                d="M8 0c4.411 0 8 2.912 8 6.492 0 1.433-.555 2.723-1.715 3.994-1.678 1.932-5.431 4.285-6.285 4.645-.83.35-.734-.197-.696-.413l.003-.018.114-.685c.027-.204.055-.521-.026-.723-.09-.223-.444-.339-.704-.395C2.846 12.39 0 9.701 0 6.492 0 2.912 3.59 0 8 0ZM5.022 7.686H3.497V4.918a.156.156 0 0 0-.155-.156H2.78a.156.156 0 0 0-.156.156v3.486c0 .041.017.08.044.107v.001l.002.002.002.002a.154.154 0 0 0 .108.043h2.242c.086 0 .155-.07.155-.156v-.56a.156.156 0 0 0-.155-.157Zm.791-2.924a.156.156 0 0 0-.156.156v3.486c0 .086.07.155.156.155h.562c.086 0 .155-.07.155-.155V4.918a.156.156 0 0 0-.155-.156h-.562Zm3.863 0a.156.156 0 0 0-.156.156v2.07L7.923 4.832a.17.17 0 0 0-.013-.015v-.001a.139.139 0 0 0-.01-.01l-.003-.003a.092.092 0 0 0-.011-.009h-.001L7.88 4.79l-.003-.002a.029.029 0 0 0-.005-.003l-.008-.005h-.002l-.003-.002-.01-.004-.004-.002a.093.093 0 0 0-.01-.003h-.002l-.003-.001-.009-.002h-.006l-.003-.001h-.004l-.002-.001h-.574a.156.156 0 0 0-.156.155v3.486c0 .086.07.155.156.155h.56c.087 0 .157-.07.157-.155v-2.07l1.6 2.16a.154.154 0 0 0 .039.038l.001.001.01.006.004.002a.066.066 0 0 0 .008.004l.007.003.005.002a.168.168 0 0 0 .01.003h.003a.155.155 0 0 0 .04.006h.56c.087 0 .157-.07.157-.155V4.918a.156.156 0 0 0-.156-.156h-.561Zm3.815.717v-.56a.156.156 0 0 0-.155-.157h-2.242a.155.155 0 0 0-.108.044h-.001l-.001.002-.002.003a.155.155 0 0 0-.044.107v3.486c0 .041.017.08.044.107l.002.003.002.002a.155.155 0 0 0 .108.043h2.242c.086 0 .155-.07.155-.156v-.56a.156.156 0 0 0-.155-.157H11.81v-.589h1.525c.086 0 .155-.07.155-.156v-.56a.156.156 0 0 0-.155-.157H11.81v-.589h1.525c.086 0 .155-.07.155-.156Z"
                                            ></path>
                                        </svg>
                                        <svg
                                            v-if="sns.name === 'instagram'"
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            fill="currentColor"
                                            class="bi bi-instagram"
                                            viewBox="0 0 16 16"
                                        >
                                            <path
                                                d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334z"
                                            ></path>
                                        </svg>
                                        <svg
                                            v-if="sns.name === 'tiktok'"
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            fill="currentColor"
                                            class="bi bi-tiktok"
                                            viewBox="0 0 16 16"
                                        >
                                            <path
                                                d="M9 0h1.98c.144.715.54 1.617 1.235 2.512C12.895 3.389 13.797 4 15 4v2c-1.753 0-3.07-.814-4-1.829V11a5 5 0 1 1-5-5v2a3 3 0 1 0 3 3V0Z"
                                            ></path>
                                        </svg>
                                    </a>
                                </div>
                                <div class="divider my-1 mx-2"></div>
                            </template>
                            <div v-if="location.tags.length > 0">
                                <div class="p-4">
                                    <button
                                        class="badge badge-default badge-outline m-1"
                                        v-for="(tag, index) in location.tags"
                                        :key="index"
                                        @click="$emit('clickTag', tag)"
                                    >
                                        #{{ tag }}
                                    </button>
                                </div>
                                <div class="divider my-1 mx-2"></div>
                            </div>
                            <div class="mx-5 justify-end flex">
                                <label for="my-modal-3" class="btn btn-sm btn-circle modal-button btn-ghost">
                                    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="20"><path d="M240-40q-33 0-56.5-23.5T160-120v-440q0-33 23.5-56.5T240-640h120v80H240v440h480v-440H600v-80h120q33 0 56.5 23.5T800-560v440q0 33-23.5 56.5T720-40H240Zm200-280v-447l-64 64-56-57 160-160 160 160-56 57-64-64v447h-80Z"/></svg>
                                </label>
                                <input type="checkbox" id="my-modal-3" class="modal-toggle" />
                                    <div class="modal">
                                        <div class="modal-box relative">
                                            <label
                                                for="my-modal-3"
                                                class="btn btn-sm btn-circle absolute right-2 top-2"
                                                >✕</label
                                            >
                                            <div>
                                                <h4 class="font-extrabold mb-2">
                                                    {{ trans.share_location }}
                                                </h4>
                                                <div class="targets">
                                                    <a
                                                        title="Share on Facebook"
                                                        :href="`https://www.facebook.com/sharer/sharer.php?u=${shareLink}`"
                                                        target="_blank"
                                                        class="button"
                                                        ><img src="/img/share-facebook.svg" alt=""
                                                    /></a>
                                                    <a
                                                        title="Share on Twitter"
                                                        :href="`https://twitter.com/intent/tweet?url=${shareLink}`"
                                                        target="_blank"
                                                        class="button"
                                                        ><img src="/img/share-x.svg" alt=""
                                                    /></a>
                                                    <a
                                                        :href="`https://social-plugins.line.me/lineit/share?url=${shareLink}`"
                                                        target="_blank"
                                                        class="button"
                                                        ><img src="/img/share-line.svg" alt=""
                                                    /></a>
                                                </div>
                                                <div class="link bg-base-300">
                                                    <div class="share-url">
                                                        {{ shareLink }}
                                                    </div>
                                                    <button
                                                        class="copy-link btn btn-primary btn-sm w-4"
                                                        @click="copyShareLink"
                                                    >
                                                        <span class="material-symbols-outlined notranslate fill-current">
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                class="h-6 w-6"
                                                                fill="none"
                                                                viewBox="0 0 24 24"
                                                                stroke="currentColor"
                                                                stroke-width="2"
                                                            >
                                                                <path
                                                                    stroke-linecap="round"
                                                                    stroke-linejoin="round"
                                                                    d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3"
                                                                />
                                                            </svg>
                                                        </span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                            </div>
                            <div
                                class="dropdown dropdown-end w-full"
                                v-if="nearestLocations.length > 0"
                            >
                                <table class="table overflow-visible">
                                    <div class="text-sm font-bold my-2 pl-2 ml-4 text-base-content text-opacity-50">
                                        <span>{{ trans.spot_detail.near_spot }}</span>
                                    </div>
                                    <tbody>
                                    <tr class="hover"
                                        v-for="location in nearestLocations"
                                        :key="'nearest-location-' + location.properties.id"
                                        @click="changeLocationDetail(location)"

                                    >
                                        <td class="flex items-center space-x-2">
                                            <div>
                                                <div
                                                    class="mask mask-squircle bg-base-content h-14 w-14 bg-opacity-10 p-px"
                                                >
                                                    <img
                                                        :src="location.properties.marker_image_url"
                                                        class="mask mask-squircle w-full h-full object-cover bg-primary"
                                                        loading="lazy"
                                                    />
                                                </div>
                                            </div>
                                            <div>
                                                <div
                                                    class="text-base font-bold break-words text-overflow-wrap"
                                                >
                                                    {{ location.properties.title }}
                                                </div>
                                                <div
                                                    class="text-base-content/70 text-sm break-words text-overflow-wrap"
                                                >
                                                    {{ location.properties.sub_title }}
                                                </div>
                                                <button class="badge badge-md my-1">
                                                    {{ location.properties.distance }}km
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import slick from '../lib/slick.min.js';
import fancybox from '@fancyapps/fancybox';
import '@fancyapps/fancybox/dist/jquery.fancybox.min.css';
import * as turf from '@turf/turf';
import AudioGuidePlayer from './AudioGuidePlayer';
import CongestionIconLevel from './CongestionIconLevel';
import ReadMoreDirective from '../custom_directives/ReadMore';

export default {
    inject: ['trans'],
    components: { AudioGuidePlayer, CongestionIconLevel },
    directives: {
        readMore: ReadMoreDirective
    },
    props: {
        location: {
            type: Object,
            default: function () {
                return null;
            }
        },
        coordinates: {
            type: Array,
            required: true
        },
        locationList: {
            type: Array,
            default: function () {
                return [];
            }
        },
        areaResource: {
            type: Array,
            default: function () {
                return [];
            }
        },
        defaultLocale: {
            type: String,
            required: false
        },
        useAudioGuide: {
            type: Boolean,
            required: true
        },
        hashId: {
            type: String,
            required: true
        },
        useMapboxDirections: {
            type: Boolean,
            default: false
        },
        useGoogleMapDirections: {
            type: Boolean,
            default: false
        },
        useCongestion: {
            type: Boolean,
            required: true
        },
        useQRCode: {
            type: Boolean,
            required: true
        },
        hideNearSpots: {
            type: Boolean,
            required: true
        },
        parcelAndLayerTitle: {
            type: String,
            default: ''
        },
        currentLayerTitle: {
            type: String,
            default: ''
        },
        isOpenedListSearchBox: {
            type: Boolean,
            required: false,
        },
        currentState: {
            type: String,
            default: ''
        },
        hasListSearchBox: {
            type: Boolean,
            default: false,
        },
        isOpenedFloorGuideBox: {
            type: Boolean,
            required: false,
        },
        hasFloorGuideBox: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            customFieldIcons: [
                {
                    regex: /address|住所/g,
                    url: '/img/place_icon.svg'
                },
                {
                    regex: /phone|電話/g,
                    url: '/img/phone_icon.svg'
                },
                {
                    regex: /url|link/g,
                    url: '/img/link_icon.svg'
                },
                {
                    regex: /hour|時間/g,
                    url: '/img/time_icon.svg'
                },
                {
                    regex: /holiday|休日/g,
                    url: '/img/village_icon.svg'
                },
                {
                    regex: /parking|駐車場/g,
                    url: '/img/parking_icon.svg'
                },
                {
                    regex: /access|アクセス/g,
                    url: '/img/directions_walk_icon.svg'
                },
                {
                    regex: /fee|入場料/g,
                    url: '/img/confirmation_number_icon.svg'
                }
            ],
            showChar: 45,
            isShare: false
        };
    },
    computed: {
        mapHeight() {
            return document.getElementById('map').offsetHeight;
        },
        isShowMore() {
            return this.location.description.length > this.showChar;
        },
        individualLink() {
            return this.location.individual_link ? this.location.individual_link.link : '';
        },
        targetIndividualLink() {
            return this.location.individual_link ? this.location.individual_link.target : '';
        },
        shareLink() {
            return window.location.origin + window.location.pathname + `?s=${this.location.id}`
        },
        nearestLocations() {
            if (this.hideNearSpots) return [];

            var point = turf.point(this.coordinates);
            var buffered = turf.buffer(point, 500);
            var currentLocationId = this.location.id;
            var result = this.locationList.filter(function (feature) {
                let to = turf.point(feature.geometry.coordinates);
                feature.properties.distance = turf.distance(point, to).toFixed(2);
                return (
                    turf.booleanPointInPolygon(feature, buffered) &&
                    feature.properties.id != currentLocationId
                );
            });
            return result
                .sort(function (a, b) {
                    return a.properties.distance - b.properties.distance;
                })
                .slice(0, 5);
        },
        showCongestion() {
            return (
                this.useCongestion &&
                this.location.current_congestion &&
                this.location.current_congestion.enable &&
                this.location.current_congestion.level
            );
        },
        qrImageURL() {
            if (!this.location.qr_image) {
                return "";
            }

            const imgPath = '/storage/qr/';
            const pattern = new RegExp(/^[A-Za-z0-9]+.(?:jpe?g|svg|png)$/, 'i');

            return pattern.test(this.location.qr_image) ? imgPath + this.location.qr_image : this.location.qr_image;
        },
        upperAreas() {
            var area = this.areaResource.find(el => el.id == this.location.area_id);
            var result = [];
            if (!area) {
                return result;
            }
            result.push(area);

            while (area.upper_area_id) {
                area = this.areaResource.find(el => el.id == area.upper_area_id);
                if (!area) {
                    break;
                }
                result.unshift(area);
            }

            return result;
        }
    },
    methods: {
        getCustomIcon(title) {
            var icon = '/img/notes_icon.svg';
            title = title.trim().toLowerCase();
            this.customFieldIcons.forEach((element) => {
                if (title.match(element.regex)) {
                    icon = element.url;
                }
            });

            return icon;
        },
        getCustomLink(title, val) {
            title = title.toLowerCase();
            if (title.indexOf('phone') != -1 || title.indexOf('電話') != -1) {
                return 'tel:' + val;
            }
            if (this.isURLField(title)) {
                return val;
            }

            return 'javascript:void(0)';
        },
        isURLField(title) {
            return title.toLowerCase().match(/url|link/g);
        },
        close() {
            this.setMetaTag();
            this.$emit('closed');
            if (this.isOpenedListSearchBox) {
                this.$emit('toggledSubSidebar', 'listSearchBox');
            }
            if (this.isOpenedFloorGuideBox) {
                this.$emit('toggledSubSidebar', 'floorGuideBox');
            }
        },
        initSlick() {
            $('.slider_img').not('.slick-initialized').slick({
                dots: true,
                speed: 300,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                dots: false,
                autoplay: false,
                autoplaySpeed: 2000,
                prevArrow:
                    '<button type="button" class="slick-prev"><svg class="h-6 w-6 fill-current md:h-8 md:w-8" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z"></path></svg></button>',
                nextArrow:
                    '<button type="button" class="slick-next"><svg class="h-6 w-6 fill-current md:h-8 md:w-8" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z"></path></svg></button>',
                infinite: false,
                asNavFor: '.thumb_list'
            });
            $('.thumb_list').slick({
                slidesToShow: 8,
                slidesToScroll: 1,
                asNavFor: '.slider_img',
                dots: false,
                arrows: false,
                centerMode: false,
                focusOnSelect: true,
                variableWidth: true,
                infinite: true
            });
        },
        initFancybox() {
            $('.fancybox').fancybox();
        },
        isYoutubeLink(str) {
            const pattern = /^https:\/\/(?:www\.)?youtube.com\/embed\/[A-z0-9]+/;
            return str.match(pattern);
        },
        isURLField(title) {
            return title.toLowerCase().match(/url|link/g);
        },
        openGoogleMap() {
            window.open(
                `https://www.google.com/maps/dir/?api=1&destination=${this.coordinates[1]},${this.coordinates[0]}`,
                ''
            );
            return false;
        },
        openDirectionsControl() {
            const nearest = this.nearestLocations.length > 0 ? this.nearestLocations[0] : '';
            var payload = [
                {
                    title: nearest ? nearest.properties.title : '',
                    coordinates: nearest ? nearest.geometry.coordinates : ''
                },
                {
                    title: this.location.title,
                    coordinates: this.coordinates
                }
            ];
            this.$emit('goToNextPoint', payload);
            this.$emit('toggledSubSidebar', 'directionsBox');
        },
        copyShareLink() {
            navigator.clipboard.writeText(this.shareLink);
        },
        hasNoAPIBanner() {
            let banners = this.location.banners;
            for (let i = 0; i < banners.length; i++) {
                if (banners[i].type == 2) return false;
            }
            return true;
        },
        changeLocationDetail(payload) {
            this.$emit('closed');
            this.$emit('changedLocationDetail', payload);
        },
        getAreaTitle(area) {
            const found = this.areaResource.find((el) => el.id == area.id);

            return found ? found.title : area.title;
        },
        handleBanner(banner) {
            this.triggerEventGA('click_activity_link', {
                id: banner.id,
                title: banner.link_title
            });
        },
        transTitle(title) {
            var lowercaseTitle = title.trim().toLowerCase();
            const pattern = {
                address: /address|住所/g,
                phone_number: /phone|電話/g,
                url: /url/g,
                business_hours: /business hours (weekdays, weekends and holidays)|営業時間/g,
                holiday: /holiday|休日/g,
                parking: /parking|駐車場/g,
                access: /access|アクセス/g,
                admission_fee: /admission Fee|入場料/g,
                remarks: /remarks|備考/g
            };
            for (const key in pattern) {
                if (lowercaseTitle.match(pattern[key])) {
                    return this.trans.spot_detail[key];
                }
            }

            return title;
        },
        setMetaTag(payload = null) {
            var title = payload ? payload.title : document.querySelector("meta[property='og:title']").getAttribute('old-content');
            var description = payload ? payload.sub_title : document.querySelector("meta[property='og:description']").getAttribute('old-content');
            var image = payload && this.location.images.length > 0 ? this.location.images[0] : document.querySelector("meta[property='og:image']").getAttribute('old-content');

            document.querySelector("meta[property='og:title']").setAttribute('content', title);
            document.querySelector("meta[property='og:description']").setAttribute('content', description);
            document.querySelector("meta[property='og:image']").setAttribute('content', image);
        },
        chooseCategory() {
            this.setMetaTag();
            this.$emit('closed');
            if (this.hasListSearchBox) {
                this.$emit('toggledSubSidebar', 'listSearchBox');
                this.$emit('selectedCategory', this.location.category);
            }
            if (this.hasFloorGuideBox) {
                this.$emit('toggledSubSidebar', 'floorGuideBox');
                this.$emit('selectedCategory', this.location.category);
            }
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.initSlick();
            this.initFancybox();
        });
        this.setMetaTag(this.location);
    }
};
</script>

<style>
@import '../../css/slick.css';
.min-height-92 {
    min-height: 92px;
}
#location_detail .thumb_list {
    border-radius: 0 0 15px 15px;
    -webkit-border-radius: 0 0 15px 15px;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    padding: 6px 10px 6px 110px;
}
.slick-slider {
    position: relative;
    display: block;
    box-sizing: border-box;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-touch-callout: none;
    -khtml-user-select: none;
    -ms-touch-action: pan-y;
    touch-action: pan-y;
    -webkit-tap-highlight-color: transparent;
}
.location-category {
    margin: 8px 10px 10px;
    position: absolute;
    top: -24px;
    right: 9px;
}
.map_section .map_detail .detail {
    overflow-y: auto;
    outline: none;
    height: auto;
    max-height: 100vh;
    z-index: 999;
    transition: all 0.3s ease;
    padding-bottom: 20px;
    -ms-overflow-style: none;
    scrollbar-width: none;
}
#location_detail .avatar_base {
    position: absolute;
    left: 15px;
    top: -44px;
    z-index: 99;
}

.slick-prev,
.slick-next {
    position: absolute;
    top: 50%;
    display: inline-block;
    cursor: pointer;
    z-index: 99;
}

.slick-prev:hover,
.slick-prev:focus,
.slick-next:hover,
.slick-next:focus {
    outline: none;
    opacity: 1;
}

.slick-prev.slick-disabled,
.slick-next.slick-disabled {
    opacity: 0.25;
}

.slick-prev {
    left: 5px;
}

.slick-next {
    right: 5px;
}

.btn-accent {
    --tw-border-opacity: 1;
    border-color: hsl(var(--a) / var(--tw-border-opacity));
    --tw-bg-opacity: 1;
    background-color: hsl(var(--a) / var(--tw-bg-opacity));
    --tw-text-opacity: 1;
    color: hsl(var(--ac) / var(--tw-text-opacity));
}
.text-overflow-wrap {
    overflow-wrap: anywhere;
}
.locationdetail-content-height {
    padding-bottom: 10rem;
}
.v-align-sub {
    vertical-align: sub;
}
@media screen and (max-width: 639px) {
    .locationdetail-content-height {
        min-height: 40rem;
        padding-bottom: 40rem;
    }
}
</style>